import React from "react";
import StoreLayout from "../components/StoreLayout";

export default function Privacy() {
  return (
    <StoreLayout>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-10 py-16">
        <p className="label-mono text-[#71717A]">// LEGAL</p>
        <h1 className="font-display font-black text-4xl md:text-6xl uppercase tracking-tight mt-3">Privacy Policy</h1>
        <p className="label-mono text-[#71717A] mt-2">LAST UPDATED // 23 MAY 2026</p>

        <div className="mt-10 space-y-8 text-[#A1A1AA] leading-relaxed">

          <section>
            <h2 className="font-display font-bold text-2xl uppercase text-white mb-3">1. Who we are</h2>
            <p>Cult Lyf (“Cult Lyf”, “we”, “us”, “our”) operates the website <span className="text-[#CFF048]">cultlyf.com</span> and sells streetwear t-shirts and related merchandise. This Privacy Policy explains how we collect, use, share and protect your personal information when you visit or buy from us.</p>
          </section>

          <section>
            <h2 className="font-display font-bold text-2xl uppercase text-white mb-3">2. Information we collect</h2>
            <ul className="list-disc ml-6 space-y-2">
              <li><strong className="text-white">Account data</strong> — name, email, encrypted password.</li>
              <li><strong className="text-white">Order data</strong> — items purchased, sizes, colors, shipping address, phone, courier and tracking number.</li>
              <li><strong className="text-white">Payment data</strong> — handled by our payment processor Stripe; we never store full card details on our servers.</li>
              <li><strong className="text-white">Usage data</strong> — pages visited, device, browser, anonymized IP, collected via Google Analytics.</li>
              <li><strong className="text-white">Communications</strong> — emails you send us and reviews you post.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-display font-bold text-2xl uppercase text-white mb-3">3. How we use your data</h2>
            <ul className="list-disc ml-6 space-y-2">
              <li>To create and manage your account.</li>
              <li>To process orders, payments and deliveries.</li>
              <li>To send transactional emails (order confirmation, status updates, shipping with tracking).</li>
              <li>To notify registered members about new drops and product launches.</li>
              <li>To improve our products, services and website experience.</li>
              <li>To prevent fraud, debug issues and comply with legal obligations.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-display font-bold text-2xl uppercase text-white mb-3">4. Sharing</h2>
            <p>We share data only with service providers that help us run the business: <strong className="text-white">Stripe</strong> (payments), <strong className="text-white">ZeptoMail / Zoho</strong> (transactional email), <strong className="text-white">Google Analytics</strong> (anonymized usage), and courier partners you choose at checkout. We do not sell your personal information.</p>
          </section>

          <section>
            <h2 className="font-display font-bold text-2xl uppercase text-white mb-3">5. Cookies</h2>
            <p>We use minimal cookies for authentication (JWT in local storage), cart persistence and analytics. You can clear cookies and local storage anytime through your browser settings; you may need to sign in again afterwards.</p>
          </section>

          <section>
            <h2 className="font-display font-bold text-2xl uppercase text-white mb-3">6. Your rights</h2>
            <p>You can request access, correction or deletion of your personal data at any time by writing to <span className="text-[#CFF048]">info@cultlyf.com</span>. We will respond within 30 days. You can also unsubscribe from product announcement emails using the link in those emails.</p>
          </section>

          <section>
            <h2 className="font-display font-bold text-2xl uppercase text-white mb-3">7. Data retention</h2>
            <p>We keep order and payment records for as long as required by tax and accounting laws (typically up to 8 years). Account and review data is kept while your account is active and deleted on request.</p>
          </section>

          <section>
            <h2 className="font-display font-bold text-2xl uppercase text-white mb-3">8. Security</h2>
            <p>Passwords are hashed with bcrypt; payment data is tokenized through Stripe; emails are sent over TLS. No system is 100% secure though — we ask you to choose a strong password and to never share it.</p>
          </section>

          <section>
            <h2 className="font-display font-bold text-2xl uppercase text-white mb-3">9. Children</h2>
            <p>Cult Lyf is not intended for users under 13. We do not knowingly collect data from children.</p>
          </section>

          <section>
            <h2 className="font-display font-bold text-2xl uppercase text-white mb-3">10. Contact</h2>
            <p>Questions about this policy? Email <span className="text-[#CFF048]">info@cultlyf.com</span>. We may update this policy from time to time; the “last updated” date will reflect any changes.</p>
          </section>

        </div>
      </div>
    </StoreLayout>
  );
}
